module.exports = require("core-js-pure/stable/set-timeout");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/set-timeout.js
// module id = 1576
// module chunks = 0